import { API } from "../src"

export const getJobStatusCount = (id) => {
  return API.get(`/job-applicant-status-count/${id}`)
}
